import { config, handleResponse } from '../../_helpers';

export const cargoTypeServices = {
    getCargoTypes,
    getCargoTypeById,
    createCargoType,
    updateCargoType,
    deleteCargoTypes,
    activation,
    getActiveCargoTypes
};

function getCargoTypes(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/CargoTypes/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/CargoTypes/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getCargoTypeById(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CargoTypes/get/${id}`, requestOptions).then(handleResponse);
}
function createCargoType(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CargoTypes`, requestOptions).then(handleResponse);
}
function updateCargoType(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CargoTypes/update/${id}`, requestOptions).then(handleResponse);
}
function deleteCargoTypes(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CargoTypes/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/CargoTypes/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActiveCargoTypes() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CargoTypes/getIsActive`, requestOptions).then(handleResponse);
}